"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
const services = [{
  title: "TIRE REPLACEMENT",
  desc: "New tire options for most passenger vehicles, with fast installation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tire_replacement_service.png",
  items: ["New tire options", "Fast installation"]
}, {
  title: "FLAT TIRE REPAIR",
  desc: "Quick flat repair, puncture repair, and leak check.",
  image: "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-5-2026-04_20_13-PM.png",
  items: ["Puncture repair", "Patch & plug"]
}, {
  title: "BRAKE SERVICE",
  desc: "Brake pads, rotors, calipers, and brake inspection.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/brake_service_repair.png",
  items: ["Pads & rotors", "Calipers"]
}, {
  title: "TPMS SERVICE",
  desc: "TPMS sensor replacement, calibration and light reset.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650379/img/tpms_sensor_service.png",
  items: ["Sensor replacement", "Calibration & reset"]
}, {
  title: "BATTERY SERVICE",
  desc: "Battery testing and fast replacement for most vehicles.",
  image: "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-5-2026-04_28_19-PM.png",
  items: ["Battery testing", "Fast replacement"]
}, {
  title: "OIL CHANGE",
  desc: "Quality oil and filter service for better engine protection.",
  image: "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-5-2026-04_47_26-PM.png",
  items: ["Oil & filter", "Full synthetic oil"]
}];
export default function OnzeReparatiediensten() {
  return <>
      {/* SERVICES */}
      <section id="services" className="bg-[#F7F9FC] pt-6 pb-6 scroll-mt-[95px]">
        <div className="max-w-[1180px] mx-auto px-3 sm:px-5 lg:px-8 w-full">
          
          {/* TITLE */}
          <div className="text-center mb-5">
            <h2 className="text-[28px] lg:text-[38px] font-black italic uppercase leading-none tracking-tight">
              <span className="text-[#0B4DBA]">Our</span>{" "}
              <span className="text-black">Services</span>
            </h2>

            <p className="mt-1 text-[#5B6575] text-[12px] md:text-[13px]">
              Fast tire and auto service in Los Angeles.
            </p>
          </div>

          {/* GRID */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">

            {services.map((s, i) => <div key={i} data-index={i} className="relative group bg-white rounded-md overflow-hidden border border-[#E3E7EF] hover:-translate-y-[3px] hover:shadow-[0_18px_36px_rgba(7,27,58,0.14)] transition-all duration-300">

                {/* IMAGE */}
                <div className="relative h-[82px] md:h-[100px] lg:h-[82px] overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                  {/* TOP LINE */}
                  <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-[#FF5A00] via-[#0B4DBA] to-[#7DB2FF]" />
                </div>

                {/* CONTENT */}
                <div className="p-2.5 md:p-3">

                  <h3 className="text-[12px] md:text-[17px] font-black italic uppercase tracking-tight leading-[1.05] mb-1 text-black">
                    {s.title}
                  </h3>

                  <p className="text-[10px] md:text-[12px] leading-snug text-[#5B6575] mb-2">
                    {s.desc}
                  </p>

                  <ul className="space-y-[2px] md:space-y-[3px]">

                    {s.items.map((item, idx) => <li key={idx} data-index={idx} className="flex items-center gap-1.5 text-[9px] md:text-[10px] font-black uppercase text-[#111827]">
                        <CircleCheck className="w-3 h-3 text-[#0B4DBA] shrink-0" />
                        {item}
                      </li>)}

                  </ul>
                </div>

                {s.title === "FLAT TIRE REPAIR" && <a href="https://novatirecenter.com/flat-tire-repair-los-angeles/" aria-label="Flat Tire Repair Los Angeles" className="absolute inset-0 z-10">
                    <span className="sr-only">Flat Tire Repair Los Angeles</span>
                  </a>}

                {s.title === "TIRE REPLACEMENT" && <a href="https://novatirecenter.com/tire-shop-los-angeles/" aria-label="New Tires - Tire Shop Los Angeles" className="absolute inset-0 z-10">
                    <span className="sr-only">New Tires - Tire Shop Los Angeles</span>
                  </a>}
              </div>)}

          </div>

          {/* BUTTON */}
          <div className="text-center mt-5">
            <Link to="#pickup" className="inline-flex items-center justify-center border-2 border-[#0B4DBA] text-[#0B4DBA] px-5 md:px-6 py-2 rounded-md font-black uppercase text-[11px] md:text-[12px] hover:bg-[#0B4DBA] hover:text-white hover:shadow-[0_12px_25px_rgba(11,77,186,0.25)] hover:-translate-y-0.5 transition-all duration-300">
              Explore Pickup Service →
            </Link>
          </div>

        </div>
      </section>

      {/* PICKUP */}
    </>;
}